import {ProgressLoaderWrapper, ProgressLoaderWrappers, LoaderSvg } from './style';
type Props = {
	progress: number;
	text: string;
}
export default function ProgressLoader(props: Props) {
	const { progress, text } = props;
	// SVG geometry calculations
	const size = 120;
	const strokeWidth = 8;
	const radius = (size - strokeWidth) / 2;
	const circumference = 2 * Math.PI * radius;

	// Ensure progress stays between 0 and 100
	const clampedProgress = Math.min(Math.max(progress, 0), 100);

	// Calculate stroke offset based on progress
	const strokeDashoffset = circumference - (clampedProgress / 100) * circumference;
	return (
		<>
			<ProgressLoaderWrapper className=''>			
				<ProgressLoaderWrappers size={size}>
					<LoaderSvg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
						<circle
							className="track"
							cx={size / 2}
							cy={size / 2}
							r={radius}
							strokeWidth={strokeWidth}
						/>
						<circle
							className="progress"
							cx={size / 2}
							cy={size / 2}
							r={radius}
							strokeWidth={strokeWidth}
							style={{
								strokeDasharray: circumference,
								strokeDashoffset: strokeDashoffset,
							}}
						/>
					</LoaderSvg>
					
					<div className="text-container">
						<span className="label">{text}</span>
						<span className="value">{clampedProgress}%</span>
					</div>
				</ProgressLoaderWrappers>
			</ProgressLoaderWrapper>
		</>
	);
}